var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "Box",
    { staticClass: "table-wrapper" },
    [
      _c("h3", [
        _c("i", { staticClass: "fas fa-upload" }),
        _vm._v(" " + _vm._s(_vm.resource("AudienceManager_OverView_Published")))
      ]),
      _vm._v(" "),
      _c("DataTable", {
        staticClass: "table table-striped",
        attrs: {
          data: _vm.publishedAudiences,
          columns: _vm.allColumns,
          options: { refresh: { enabled: true }, filter: { enabled: false } },
          loading: _vm.loading || _vm.loadingAudiences
        },
        on: {
          refresh: function($event) {
            return _vm.$emit("refresh")
          },
          "add-channels": function($event) {
            _vm.selectedId = $event.id
          },
          overview: function($event) {
            return _vm.navigateToOverview($event.id)
          }
        }
      }),
      _vm._v(" "),
      _vm.selectedId
        ? _c("Channels", {
            attrs: { id: _vm.selectedId },
            on: {
              hidden: function($event) {
                _vm.selectedId = null
              }
            }
          })
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }